<div *ngIf="showInitial" class="box-initial">
    <p class="secondary-text" *ngIf="showTextEmpty">¡Estás de suerte! No hay ningún pedido en espera.</p>
</div>
<div class="card-payment top" *ngFor="let systemPayment of systemPaymentData"
    [ngStyle]="{ width : isSent ? '140px' : (sizeCard[systemPayment.attributes.size] + 'px')}">
    <div class="icon-system payment-{{systemPayment.id}}">
        <div class="container-system-icon">
            <app-system-icon systemId="{{system.id}}" title="{{system.attributes.name}}"
                alt="{{system.attributes.name}}" size="medium" width="36" height="36">
            </app-system-icon>
        </div>
        <div class="container-state">
            <img src="https://panel.saldo.com.ar/img/states-public/{{isSent ? 22 : 12 }}.png"
                alt="Estado de la transacción">
        </div>
    </div>
    <div *ngIf="paymentId === systemPayment.id" class="tooltip-payment-queue"
        [ngStyle]="{ width : isSent ? '142px' : (sizeCard[systemPayment.attributes.size] + 2 + 'px')}">
        <p>Tu pedido</p>
    </div>
    <div class="card-filled"
        [ngStyle]="{ width: isSent ? '140px': (sizeCard[systemPayment.attributes.size] + 'px'), height: isSent ? '140px': (setFilledAndFillingCard(systemPayment.attributes.filled) + 'px')}">
    </div>
    <div class="card-filling"
        [ngStyle]="{ width: isSent ? '140px' : (sizeCard[systemPayment.attributes.size] + 'px'), height: isSent ? '140px': (setFilledAndFillingCard(systemPayment.attributes.filled + systemPayment.attributes.filling) + 'px')}">
    </div>
    <span class="tiptext">
        <p>Tiempo de espera promedio <b>{{ system.relationships.system_information.data[0].attributes.time_average}} hs</b></p>
        <p>{{isSent ? 'Finalizado' : 'En espera'}} <b>{{getWaitTime(systemPayment)}}</b></p>
        <p>Fondos recibidos <b>{{isSent ? 100 : systemPayment.attributes.filled}}%</b></p>
    </span>
</div>
